import React, { useState } from "react";
import Button from "../../components/Button/Button";
import styles from "./Header.module.scss";
import { ReactComponent as ShareIcon } from "../../assets/share-icon.svg";
import { ReactComponent as HamburgerIcon } from "../../assets/hamburger.svg";
import { ReactComponent as CloseIcon } from "../../assets/close.svg";
import { strings } from "../../strings";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div id={"#"} className={styles.wrapper}>
      <div
        onClick={() => {
          setIsOpen(true);
        }}
        className={styles.hamburgerMenu}
      >
        <HamburgerIcon />
      </div>
      <h1 className={styles.logo}></h1>
      <div className={styles.links}>
        <a className={styles.active} href="##">
          {strings.navLinks[1]}
        </a>
        <a href="#collection"> {strings.navLinks[2]}</a>
        <a href="#team"> {strings.navLinks[3]}</a>
        {/* <a href="#faq"> {strings.navLinks[4]}</a> */}
      </div>
      <div className={styles.action}>
        <Button text={strings.navBtn} icon={<ShareIcon />} />
      </div>
      {isOpen && <FullNav setIsOpen={setIsOpen} />}
    </div>
  );
}
const FullNav = ({ setIsOpen }) => {
  return (
    <div className={styles.fullNav}>
      <h1 className={styles.logo}>{strings.logo}</h1>
      <div className={styles.fullLinks}>
        <a
          onClick={() => {
            setIsOpen(false);
          }}
          className={styles.active}
          href="##"
        >
          {strings.navLinks[1]}
        </a>
        <a
          onClick={() => {
            setIsOpen(false);
          }}
          href="#collection"
        >
          {strings.navLinks[2]}
        </a>
        <a
          onClick={() => {
            setIsOpen(false);
          }}
          href="#team"
        >
          {strings.navLinks[3]}
        </a>
        {/* <a
          onClick={() => {
            setIsOpen(false);
          }}
          href="#faq"
        >
          {strings.navLinks[4]}
        </a> */}
      </div>
      <CloseIcon
        onClick={() => {
          setIsOpen(false);
        }}
      />
    </div>
  );
};
